import { Injectable } from '@angular/core';
import { IListingSetup } from '@df/catalog-ui/listing/listing';
import { IProductListingConfig } from '@df/catalog-ui/listing/product-listing';
import { ProductListingFactory } from '@df/catalog-ui/listing/product-listing.factory';
import { IProductDataV2, Product } from '@df/catalog/product/product';
import { ProductListing } from './product-listing.decorator';

@Injectable()
export class ProductListingFactoryDecorator extends ProductListingFactory {
    override create<T extends Product = Product<IProductDataV2>>(
        config: Partial<IProductListingConfig>,
        models: T[] | number[],
        setup: IListingSetup<T> = {}
    ): ProductListing<T> {
        return new ProductListing<T>(config, models, setup);
    }
}
